import "zapt-maps-sdk/dist/css/map.css";
import videoMapNTO from "../assets/video/Hermes_pardini_Introv4.mp4";
import videoGeneric from "../assets/video/generic-map.mp4";
import {
  MAIN_ID,
  MAIN_MAP,
  PRODUCTION_UNIT_HAS_MAP,
  ZAPT_API_KEY,
  PRODUCTION_UNIT_CATEGORY,
  PRODUCTION_UNIT_FEDERATIONS,
  PRODUCTION_UNIT_ALIAS,
  STAGES_CATEGORY,
  STAGE_COLORS,
  STAGE_SHORT,
  STAGE_ICONS,
  UNIT_IMG_CARD,
  STAGE_COLORS_UPPERCASE,
  STAGE_COLOR_CODE,
  STATES_CATEGORY,
} from "../constants";

import { MAP_ANIMATIONS } from "../animations/mapAnimations";
import { HISTORY_ROUTES_GENERIC, HISTORY_ROUTES_FLAT, HISTORY_ROUTES_FLAT_GENERIC, HISTORY_ROUTES } from '../routes/historyRoutes'
import React, { Component } from "react";

import ZaptMapAPI from "zapt-maps-sdk";
import { withRouter } from "react-router";
import {
  filterPoiByName,
  filterPois,
  sendEvent,
  transformCoordinatesToLeaflet,
  getCoordinateDirection,
  calculateCurvePoints,
  addPaddingInMap,
} from "../util/utils";
import userService from "../services/UserService";
import LoadDNA from "./LoadDNA";
import moment from "moment";
import imageCardRegistered from '../assets/img/PIN-NTS/pin-card-registered.png';
class Map extends Component {
  constructor(props) {
    super(props);

    this.state = {
      videoIsPlaying: false,
      videoVisible: false,
      videoPath: "",
      loading: true,
      mapId: "",
      flatMapId: "",
      flatMapExternalId: "",
      mapExternalId: "",
      placeId: "",
      mapSelectedType: "3D",
      currentMapId: "",
      mainMapId: "",
      mainMapExternalId: MAIN_MAP,
      mainFlatMapId: "",
      exams: null,
      examHistory: null,
      isMapInitialized: false,
      examOnHighlight: null,
      windowWidth: window.innerWidth,
      isStageHighlightOn: false,
      fullLegend: false,
    };

    this.containerHeight = window.innerHeight;
    this.zaptMapAPI = null;
    this.markers = {};
    this.logisticRoutes = [];
    this.mapBounds = [];
    this.contextChangeRequestPool = Promise.resolve();
    this.isOnUnitCardOver = false;
    this.clearLogisticLabelsFn = this.clearLogisticLabels.bind(this);
    this.renderLegendFn = this.renderLegend.bind(this);
    this.highlightStageFn = this.highlightStage.bind(this);
  }

  async componentDidMount() {
    this.startListeningEvents();
    sendEvent("load-first-map");
  }

  componentWillUnmount() {
    this.stopListeningEvents();
  }

  startListeningEvents() {
    window.addEventListener(
      "load-first-map",
      this.changeContextHandler.bind(this)
    );
    window.addEventListener("draw-exams", this.changeContextHandler.bind(this));
    window.addEventListener(
      "draw-history",
      this.changeContextHandler.bind(this)
    );
    window.addEventListener("highlight-exam", this.highlightExam.bind(this));
    window.addEventListener("reset-map-zoom", this.resetMapZoom.bind(this));

    this.highlightUnitFn = (event) => {
      if (event && event.detail) {
        let [productionUnit, focus] = event.detail;
        this.highlightUnit(productionUnit, focus);
      }
    };

    window.addEventListener("highlight-unit", this.highlightUnitFn.bind(this));
    window.addEventListener("highlight-stage", this.changeContextHandler.bind(this));
    window.addEventListener(
      "reset-markers",
      this.changeContextHandler.bind(this)
    );
  }

  stopListeningEvents() {
    window.removeEventListener(
      "load-first-map",
      this.changeContextHandler.bind(this)
    );
    window.removeEventListener(
      "draw-exams",
      this.changeContextHandler.bind(this)
    );
    window.removeEventListener(
      "draw-history",
      this.changeContextHandler.bind(this)
    );
    window.removeEventListener("highlight-exam", this.highlightExam.bind(this));
    window.removeEventListener(
      "highlight-unit",
      this.highlightUnitFn.bind(this)
    );
    window.removeEventListener("reset-map-zoom", this.resetMapZoom.bind(this));
    window.removeEventListener(
      "highlight-stage",
      this.highlightStageFn
    );
    window.removeEventListener(
      "reset-markers",
      this.changeContextHandler.bind(this)
    );
    global.zapt && global.zapt.map &&
    global.zapt.map.off('move viewreset moveend zoomanim', this.renderLegendFn);
  }

  setMapContainer() {
    if (document.getElementById("header")) {
      this.containerHeight =
        window.innerHeight - document.getElementById("header").clientHeight;
    } else {
      this.containerHeight = window.innerHeight;
    }
  }

  async loadFirstMap() {
    return new Promise(async (resolve, reject) => {
      let requestChangeContext = async (resolve) => {
        await this.handleMapView();
        resolve();
      };
      this.setMapContainer();
      await this.handleMapView();
      this.setState(
        { isMapInitialized: true },
        requestChangeContext.bind(this, resolve)
      );
    });
  }

  serialize = (fn) => {
    return (...args) => {
      this.contextChangeRequestPool = this.contextChangeRequestPool.then(() =>
        fn(...args)
      );
      this.contextChangeRequestPool.catch((error) => {
        console.error("Error on serialize function execution:  ", error.message);
      });
      return this.contextChangeRequestPool;
    };
  };

  changeContextHandler = this.serialize(
    (() => {
      return async (args) => {
        if (args && args.type === "reset-markers") {
          if (args.detail && args.detail.update) {
            !this.state.isStageHighlightOn && (await this.handleMapView(false));
          } else {
            await this.handleMapView(false);
            this.setState({ isStageHighlightOn: false });
          }
          return;
        } else if (args && args.type === "draw-exams") {
          await this.setExams(args);
          return;
        } else if(args && args.type === "highlight-stage"){
          await this.highlightStageFn(args);
          return;
        }
        else if (args && args.type === "draw-history") {
          await this.setExamHistory(args);
          return;
        } else if (args && args.type === "load-first-map") {
          await this.loadFirstMap();
          return;
        }
      };
    })()
  );

  async loadMap(externalMapId) {

    if (
      externalMapId &&
      (externalMapId !== this.state.currentExternalMapId)
    ) {
      this.setState({ loading: true });
      await this.initializeMap(externalMapId);
      this.setState({
        loading: false,
        videoVisible: false,
      });
    } else if (
      this.state.mapExternalId !== MAIN_MAP
    ) {
      this.setState({ loading: true, mapExternalId: MAIN_MAP });
      this.state.mapSelectedType === "FLAT"
        ? await this.initializeMap(`${MAIN_MAP}-FLAT`)
        : await this.initializeMap(`${MAIN_MAP}`);
        this.setState({ loading: false });
      }
      
    this.checkIfIsDefaultProductionUnitMap() &&
    global.zapt.map.on('move viewreset moveend zoomanim', this.renderLegendFn);
    return true;
  }

  async initializeMap(externalMapId) {
    if(this.state.windowWidth <= 820){
      addPaddingInMap({left: 0});
    }else{
      addPaddingInMap({left: 36});
    }
    if (externalMapId) {
      try {
        let mainExternalId = externalMapId.replace("-FLAT", "");

        if(!PRODUCTION_UNIT_HAS_MAP[mainExternalId]){
          if(this.checkIfIsFlatMapId(externalMapId)){
            externalMapId = "GENERIC-FLAT"
          }else{
            externalMapId = "GENERIC"
          }
        }

        if (this.zaptMapAPI) {
          let mapId = null;
          let flatMatId = null;

          if (!this.checkIfIsFlatMapId(externalMapId)) {
            mapId = await this.zaptMapAPI.Data.getMapId(
              this.state.placeId,
              externalMapId
            );

            flatMatId = await this.zaptMapAPI.Data.getMapId(
              this.state.placeId,
              externalMapId + "-FLAT"
            );

            this.setState({
              mapId: mapId,
              flatMapId: flatMatId,
              currentMapId: mapId,
              currentExternalMapId: externalMapId,
              flatMapExternalId: externalMapId + "-FLAT",
              mapExternalId: mainExternalId,
              mapSelectedType: "3D",
            });

            await this.zaptMapAPI.setMapId(mapId);
            this.updateLimitMapBounds(30);
          } else {
            flatMatId = await this.zaptMapAPI.Data.getMapId(
              this.state.placeId,
              externalMapId
            );

            this.setState({
              flatMapId: flatMatId,
              currentMapId: flatMatId,
              currentExternalMapId: externalMapId,
              flatMapExternalId: externalMapId,
              mapExternalId: mainExternalId,
              mapSelectedType: "FLAT",
            });

            await this.zaptMapAPI.setMapId(flatMatId);
            this.updateLimitMapBounds(25);
          }
        } else {
          this.zaptMapAPI = new ZaptMapAPI(ZAPT_API_KEY);

          let placeId = await this.zaptMapAPI.Data.getPlaceId(MAIN_ID);

          if (!placeId) {
            return console.error(
              "Error on map initialization: invalid or empty place id."
            );
          }

          this.setState({ placeId: placeId });

          let mapId = await this.zaptMapAPI.Data.getMapId(
            placeId,
            externalMapId
          );
          let flatMatId = await this.zaptMapAPI.Data.getMapId(
            placeId,
            externalMapId + "-FLAT"
          );

          this.setState({
            mapId: mapId,
            flatMapId: flatMatId,
            currentMapId: mapId,
            currentExternalMapId: externalMapId,
            flatMapExternalId: externalMapId + "-FLAT",
            mapSelectedType: "3D",
          });

          if (externalMapId === MAIN_MAP) {
            this.setState({
              mainMapId: mapId,
              mainFlatMapId: flatMatId,
            });
          }

          let mapParams = {
            mapContainerId: "zapt-map",
            disableShowInterestPopUponClick: true,
            height: this.containerHeight,
            disableCache: true,
            showPins: false,
            disablePopUpDynamicPin: true,
          };

          await this.zaptMapAPI.initialize(mapId, mapParams);
        }
      } catch (error) {
        console.error("Unexpected Error on map initialization:", error.message);
      }
    } else {
      console.error(
        "Error on map initialization: invalid or empty external id."
      );
    }
  }

  addAnimationsInMap(productionUnit) {
    if (
      global.L &&
      global.zapt &&
      global.zapt.map &&
      this.state.mapSelectedType &&
      this.state.mapSelectedType !== "FLAT" &&
      productionUnit !== "HP"
    ) {
      
      let animations = null;
      if(PRODUCTION_UNIT_HAS_MAP[productionUnit]){
        animations = MAP_ANIMATIONS[productionUnit];
      }else{
        animations = MAP_ANIMATIONS['GENERIC'];
      }
      if(animations){
        for(let animationKey in animations){
          let animation = animations[animationKey];
          if(animation.gifPath && animation.coords && animation.coords.length >= 2){
              global.L.imageOverlay(animation.gifPath,
                animation.coords
              ).addTo(global.zapt.map);
          }
        }
      }
    }
  }

  async handleMapView(resetZoom = true) {
    let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();
    let examsDistribution = this.getExamsDistribution();

    if (this.state.examHistory) {
      await this.handleExamHistoryMapView(this.state.examHistory);
    } else if (this.state.exams === "no-results") {
      await this.clearMapView();
    } else if (this.state.isMapInitialized && examsDistribution) {
      await this.handleProductionUnitExamDistributionMapView(
        examsDistribution,
        isDefaultProductionUnit
      );
    } else {
      await this.handleMainMapView(resetZoom);
    }
  }

  async handleMainMapView(resetZoom){
    try {
      sendEvent("setCurrentProductionUnit", MAIN_MAP);
      await this.loadMap();
      await this.loadProductionUnits(resetZoom);

    } catch (error) {
      console.error("Error trying to handle main map view: ", error);
    }
  }

  async handleExamHistoryMapView(examHistory) {
    try {
      let lastStage = examHistory &&
        examHistory.examHistory &&
        examHistory.examHistory[examHistory.examHistory.length -1];
      let productionUnit = examHistory.productionUnit
      if(lastStage && lastStage.stageName === 'Recolhido'){
        let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();
        if(!isDefaultProductionUnit){
          await this.handleMainMapView(false);
        }
        await this.loadCollectedMarkers({[productionUnit]: {TOTAL: 1}}, false, true);
        addPaddingInMap({left: 0});
        global.zapt && global.zapt.map && global.zapt.map.invalidateSize();
        return;
      }
      if(lastStage &&lastStage.stageName === 'Cadastrado'){
        let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();
        if(!isDefaultProductionUnit){
          await this.handleMainMapView(false);
        }
        await this.loadRegisteredMarker({"BR": {TOTAL: 1}}, false, true);
        addPaddingInMap({left: 0});
        global.zapt && global.zapt.map && global.zapt.map.invalidateSize();
        return;
      }
      let mapExternalId = this.state.mapSelectedType === 'FLAT' ? examHistory.productionUnit+'-FLAT' : examHistory.productionUnit;
      this.state.mapExternalId !== examHistory.productionUnit &&
        sendEvent("setCurrentProductionUnit", examHistory.productionUnit) &&
        (await this.loadMap(mapExternalId)) &&
        this.addAnimationsInMap(mapExternalId);
      
      this.loadHistoryOnMap(examHistory);
    } catch (error) {
      console.error("Error trying to handle exam history map view: ", error);
    }
  }

  getClientState(){
    return this.props.status &&
           this.props.status['BR'] && 
           this.props.status['BR'].clientState;
  }

  getClientName(stage, unitName){
    if(userService.getUserType() === "PSC"){
      if(this.props.stageUnitDistributionByStage && 
        this.props.stageUnitDistributionByStage[stage+'-LOCATION'] &&
        this.props.stageUnitDistributionByStage[stage+'-LOCATION'][unitName] &&
        this.props.stageUnitDistributionByStage[stage+'-LOCATION'][unitName]['namePardiniStore'])
      {
        return this.props.stageUnitDistributionByStage[stage+'-LOCATION'][unitName]['namePardiniStore']
      }
    }else{
      let userName = userService.getClientName();
      return userName || "";
    }
  }

  getClientId(stage, unitName){
    if(userService.getUserType() === "PSC"){
      if(this.props.stageUnitDistributionByStage && 
        this.props.stageUnitDistributionByStage[stage+'-LOCATION'] &&
        this.props.stageUnitDistributionByStage[stage+'-LOCATION'][unitName] &&
        this.props.stageUnitDistributionByStage[stage+'-LOCATION'][unitName]['codePardiniStore'])
      {
        return this.props.stageUnitDistributionByStage[stage+'-LOCATION'][unitName]['codePardiniStore']
      }
    }else{
      let userID = userService.getClientId();
      return userID || "";
    }
  }

  checkOnlyRegisteredOrCollected(examsDistribution){
    let result = false;
    if(examsDistribution){
      result = true;
      for(let unitKey of Object.keys(examsDistribution)){
        for(let stageKey of Object.keys(examsDistribution[unitKey])){
            stageKey = stageKey.toUpperCase();
            if(stageKey !== "CADASTRADO" &&
              stageKey !== "CADASTRADO-LOCATION" &&
              stageKey !== "RECOLHIDO" &&
              stageKey !== "RECOLHIDO-LOCATION" &&
              stageKey !== "TOTAL" &&
              stageKey !== "ALIASPRODUNIT" &&
              stageKey !== "CLIENTSTATE")
            {
              result = false;
            }
        }
      }
    }
    return result;
  }

  async handleProductionUnitExamDistributionMapView(
    examsDistribution,
    isDefaultProductionUnit
  ) {
    try {
      let isExamsInOneUnit =
        Object.keys(this.state.exams.statistics).length === 2;
        let hasSingleStatus = this.checkForSingleStatus(examsDistribution);
      if (isExamsInOneUnit &&
          !this.checkOnlyRegisteredOrCollected(examsDistribution))
      {
        let productionUnit = Object.keys(examsDistribution)[0];

          let videoPath = (productionUnit === "NTO") ? videoMapNTO : videoGeneric;
          if(
            this.state.mapExternalId !== productionUnit && 
            this.state.mapSelectedType !== 'FLAT'
          ){
            this.setState({
              videoVisible: true,
              videoPath: videoPath,
            });
          }
          let mapExternalId = this.state.mapSelectedType === 'FLAT' ? productionUnit+'-FLAT' : productionUnit;
          this.state.mapExternalId !== productionUnit &&
            sendEvent("setCurrentProductionUnit", productionUnit) &&
            (await this.loadMap(mapExternalId)) &&
            this.addAnimationsInMap(mapExternalId);
            
          examsDistribution && (await this.loadExamGroupings(examsDistribution));
 
      } else if (examsDistribution) {
        !isDefaultProductionUnit &&
          sendEvent("setCurrentProductionUnit", MAIN_MAP) &&
          (await this.loadMap());
          if(hasSingleStatus){
            switch(hasSingleStatus){
              case "CADASTRADO":
                await this.loadRegisteredMarker(examsDistribution);
                break;
              case "RECOLHIDO":
                await this.loadCollectedMarkers(examsDistribution);
                break;
              default: await this.loadProductionUnitsSearch(examsDistribution);
            }
          }else{
            await this.loadProductionUnitsSearch(examsDistribution);
          }
      }
    } catch (error) {
      console.error(
        "Error trying to handle exam production unit exam distribution map view: ",
        error
      );
    }
  }

  async clearMapView() {
    try {
      await this.loadMap();
      this.clearMarkers();
    } catch (error) {
      console.error("Error trying to clear map view: ", error);
    }
  }

  async renderCardUnit(unitName, status, isHistory, isFederation, stage="") {
    if (unitName && status) {
      let clientName = stage && status && this.getClientName(stage, Object.keys(status).shift());
      let userType = userService.getUserType();
      let pois = await this.zaptMapAPI.getPois();
      let poisCategory = isFederation ? STATES_CATEGORY : PRODUCTION_UNIT_CATEGORY;
      let productionUnitPois = filterPois(
        pois,
        this.state.currentMapId,
        poisCategory
      );
      let poi = filterPoiByName(productionUnitPois, unitName);
      let statusUnit = isFederation ? status["BR"] : status[unitName];
      let stages = {};

      Object.keys(STAGE_SHORT).forEach((index) => {
        if (!statusUnit[index]) {
          stages[index] = 0;
        }else{
          stages[index] = statusUnit[index];
        }
      });
      let total = statusUnit["TOTAL"];

      if (this.markers["unit-card"]) {
        this.markers["unit-card"].remove();
        delete this.markers["unit-card"];
      }

      this.markers["unit-card"] = global.L.marker(
        global.L.latLng(poi.y, poi.x),
        {
          icon: global.L.divIcon({
            className: "",
            html: `
            <div class="card-unit" data-ignore="true">
            <img class='card-unit-image${
              unitName === "*NTO" ? "-nto" : ""
            }' id='ico-${unitName}'
            src=${UNIT_IMG_CARD[unitName] || imageCardRegistered} data-ignore="true">
            <div class="card-unit-title" data-ignore="true">
              ${statusUnit.aliasProdUnit ? statusUnit.aliasProdUnit : 
                userType === "PSC" ? 
                "HERMES PARDINI "+clientName:
                clientName}
                <span class="unit-state"></span>
            </div>
            ${Object.keys(stages).map(
              (item) => `
            <div
              id='option-${item}'
              ${!stages[item] && 'data-ignore="true"'}
              class="unit-exam-status unit-exam-status-${STAGE_ICONS[item]}"
            >
              ${STAGE_SHORT[item]}<span class="exam-status-qty">${
                stages[item]
              }</span>
            </div>
            `
            )}
            <hr class="card-divider" data-ignore="true" />
            <div id='total-${unitName}' class="unit-exam-status unit-exam-status-total">
              Total <span class="exam-status-qty">${total}</span>
            </div>
          </div>
            `.replaceAll(",", ""),
            iconAnchor: [0, 0],
            iconSize: [240, 300],
          }),
        }
      );

      this.markers["unit-card"].setZIndexOffset(1000);

      this.markers["unit-card"].on("mouseover", () => {
        this.isOnUnitCardOver = true;
      });

      this.markers["unit-card"].on("mouseout", () => {
        this.isOnUnitCardOver = false;
        if (this.markers["unit-card"]) {
          this.markers["unit-card"].remove();
          delete this.markers["unit-card"];
        }
        this.highlightUnit();
      });

      let group = new global.L.featureGroup([this.markers["unit-card"]]);

      group.addTo(global.zapt.map);

      let totalUnit = document.getElementById(`total-${unitName}`);

      if(!isHistory){
        Object.keys(stages).forEach((item) => {
          if (stages[item]) {
            let stageElement = document.getElementById(`option-${item}`);
            if (stageElement && stageElement.style) {
              stageElement.style.cursor = "pointer";
              stageElement.addEventListener("click", () => {
                sendEvent("apply-stage-production-unit-filter", {
                  productionUnit: unitName,
                  stage: item,
                });
              });
            }
          }
        });

        if (totalUnit) {
          totalUnit.style.cursor = "pointer";
          totalUnit.addEventListener("click", () => {
            sendEvent("apply-production-unit-filter", {
              productionUnit: unitName,
            });
          });
        }
      }
    }
  }

  removeCardUnit(e) {
    if (
      e &&
      e.originalEvent &&
      e.originalEvent.target &&
      e.originalEvent.target.dataset["ignore"] &&
      e.originalEvent.target.dataset["ignore"] === "true"
    ) {
      return false;
    }

    if (
      this.markers &&
      this.markers["unit-card"] &&
      this.markers["unit-card-route"]
    ) {
      global.zapt.map.removeLayer(this.markers["unit-card"]);
      global.zapt.map.removeLayer(this.markers["unit-card-route"]);
      delete this.markers["unit-card"];
      delete this.markers["unit-card-route"];
    }
  }

  focusOnTheMap(map, group, options = {}) {
    let isDefaultProductionUnitMap = this.checkIfIsDefaultProductionUnitMap();
    let maxZoom = isDefaultProductionUnitMap ? -0.33 : null;
    if(maxZoom != null){
      options.maxZoom = maxZoom
    }
    if (map) {
      map.flyToBounds(
        group.getBounds(),
        options
      );
    }
  }

  async loadProductionUnits(resetZoom) {
    resetZoom && this.resetMapZoom();
    let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();
    let isMapInitialized =
      this.zaptMapAPI &&
      this.zaptMapAPI._map.map &&
      global.L &&
      global.zapt &&
      global.zapt.map;
    let statusData =
      this.props.status &&
      Object.keys(this.props.status).length > 0 &&
      this.props.status;
    let hasSingleStatus = this.checkForSingleStatus(statusData);
    let focusOnMarkers = [];

    if (isDefaultProductionUnit && isMapInitialized && statusData) {
      let pois = await this.zaptMapAPI.getPois();

      let productionUnitPois = filterPois(
        pois,
        this.state.currentMapId,
        PRODUCTION_UNIT_CATEGORY
      );

      let isValidProductionUnitMap = this.checkIfIsProductionUnitHasMap();

      if (productionUnitPois) {
        this.clearMarkers();

        for (const index in productionUnitPois) {
          const productionUnitPoi = productionUnitPois[index];
          const isProductionUnitPoiWithMap = this.checkIfIsProductionUnitHasMap(
            productionUnitPoi.title
          );

          if (!isValidProductionUnitMap) {
            continue;
          }

          let hasProductionUnitExams =
            statusData[productionUnitPoi.title] &&
            statusData[productionUnitPoi.title]["TOTAL"];

          if (!hasProductionUnitExams) {
            continue;
          }

          this.markers[productionUnitPoi.title] = global.L.marker(
            global.L.latLng([productionUnitPoi.y, productionUnitPoi.x]),
            {
              icon: global.L.divIcon({
                className: "",
                html: `
                 <div
                  class="pin ${
                    STAGE_COLORS_UPPERCASE[hasSingleStatus] || "pin-tube"
                  }" 
                 > 
                  <div class="pin-unit-label">
                    <span class="pin-unit-name"> ${
                      statusData[productionUnitPoi.title]?.aliasProdUnit || ""
                    }</span>
                    <span class="pin-unit-qty" style="background: ${
                      STAGE_COLOR_CODE[hasSingleStatus]
                    };">${
                  (statusData[productionUnitPoi.title] &&
                    statusData[productionUnitPoi.title]["TOTAL"]) ||
                  "0"
                }</span>
                  </div>
                  <div class="pin-pulse"><span></span></div>
                </div>`,
                iconAnchor: [20, 40],
                iconSize: [40, 80],
              }),
            }
          );

          this.markers[productionUnitPoi.title].on("click", () => {
            sendEvent("apply-production-unit-filter", {
              productionUnit: productionUnitPoi.title,
            });
          });

          this.markers[productionUnitPoi.title].on("mouseover", async () => {
            let examsList = (this.state.exams && this.state.exams !== "no-results") ?
              this.state.exams.statistics :
              this.props.status;
            await this.renderCardUnit(
              productionUnitPoi.title,
              examsList,
              false,
              false,
              isProductionUnitPoiWithMap
            );
            this.highlightUnit(productionUnitPoi.title);
          });

          this.markers[productionUnitPoi.title].on("mouseout", () => {
            setTimeout(() => {
              !this.isOnUnitCardOver && this.markers["unit-card"]?.remove();
              !this.isOnUnitCardOver && this.highlightUnit();
            }, 10);
          });

          this.markers[productionUnitPoi.title].addTo(global.zapt.map);
          focusOnMarkers.push(this.markers[productionUnitPoi.title]);
        }

        if (resetZoom && focusOnMarkers.length > 0) {
          let group = new global.L.featureGroup(focusOnMarkers);
          setTimeout(() => {
            this.state.exams !== "no-results" &&
              this.focusOnTheMap(global.zapt.map, group);
            }, 1000);
          global.zapt.map.flyToBounds(global.zapt.map.getBounds())
        }
      }
    }
  }

  async loadProductionUnitsSearch(status) {
    let isMapInitialized =
      this.zaptMapAPI &&
      this.zaptMapAPI._map.map &&
      global.L &&
      global.zapt &&
      global.zapt.map;
    let statusData = status && Object.keys(status).length > 0 && status;
    let hasSingleStatus = this.checkForSingleStatus(statusData);
    let focusOnMarkers = [];

    if (isMapInitialized && statusData) {
      let pois = await this.zaptMapAPI.getPois();

      let productionUnitPois = filterPois(
        pois,
        this.state.currentMapId,
        PRODUCTION_UNIT_CATEGORY
      );

      if (productionUnitPois) {
        this.clearMarkers();

        for (const index in productionUnitPois) {
          const productionUnitPoi = productionUnitPois[index];
          const isProductionUnitPoiWithMap = this.checkIfIsProductionUnitHasMap(
            productionUnitPoi.title
          );

          let hasProductionUnitExams =
            statusData[productionUnitPoi.title] &&
            statusData[productionUnitPoi.title]["TOTAL"];

          if (!hasProductionUnitExams) {
            continue;
          }

          this.markers[productionUnitPoi.title] = global.L.marker(
            global.L.latLng([productionUnitPoi.y, productionUnitPoi.x]),
            {
              icon: global.L.divIcon({
                className: "",
                html: `
                 <a 
                 class="pin ${
                   STAGE_COLORS_UPPERCASE[hasSingleStatus] || "pin-tube"
                 }" 
                 > 
                  <div class="pin-unit-label">
                    <span class="pin-unit-name"> ${
                      statusData[productionUnitPoi.title]?.aliasProdUnit || ""
                    }</span>
                    <span class="pin-unit-qty" style="background: ${
                      STAGE_COLOR_CODE[hasSingleStatus]
                    };">${
                  (statusData[productionUnitPoi.title] &&
                    statusData[productionUnitPoi.title]["TOTAL"]) ||
                  "0"
                }</span>
                  </div>
                  <div class="pin-pulse"><span></span></div>
                </a>`,
                iconAnchor: [20, 40],
                iconSize: [40, 80],
              }),
            }
          );

          this.markers[productionUnitPoi.title].on("click", () => {
            sendEvent("apply-production-unit-filter", {
              productionUnit: productionUnitPoi.title,
            });
          });

          this.markers[productionUnitPoi.title].on("mouseout", () => {
            setTimeout(() => {
              !this.isOnUnitCardOver && this.markers["unit-card"]?.remove();
              !this.isOnUnitCardOver && this.highlightUnit();
            }, 10);
          });

          this.markers[productionUnitPoi.title].on("mouseover", async () => {
            let examsList = (this.state.exams && this.state.exams !== "no-results") ?
              this.state.exams.statistics :
              this.props.status;
            await this.renderCardUnit(
              productionUnitPoi.title,
              examsList,
              false,
              false,
              isProductionUnitPoiWithMap
            );
            this.highlightUnit(productionUnitPoi.title);
          });

          this.markers[productionUnitPoi.title].addTo(global.zapt.map);
          focusOnMarkers.push(this.markers[productionUnitPoi.title]);
        }

        if (focusOnMarkers.length > 0) {
          let group = new global.L.featureGroup(focusOnMarkers);

          this.focusOnTheMap(
            global.zapt.map, 
            group, 
          );
        }
      }
    }
  }

  async loadRegisteredMarker(status, isHighlight = false, isHistory=false) {
    let isMapInitialized =
      this.zaptMapAPI &&
      this.zaptMapAPI._map.map &&
      global.L &&
      global.zapt &&
      global.zapt.map;
    let statusData = status && Object.keys(status).length > 0 && status;
    let focusOnMarkers = [];
    let userType = userService.getUserType();
    let unitProduction = "";
    for(let unit in statusData){
      if(unit !== 'BR'){
        unitProduction = unit;
      }
    }
    let clientID = this.getClientId("CADASTRADO", unitProduction);
    
    if (isMapInitialized && (statusData || isHistory)) {
      let pois = await this.zaptMapAPI.getPois();

      let statePois = filterPois(
        pois,
        this.state.currentMapId,
        STATES_CATEGORY,
      );

      let clientState = this.getClientState();
      let statePoi = filterPoiByName(statePois, clientState);
      if (statePoi) {
        this.clearMarkers();
        if(isHistory){
          global.L.polygon([[-3360,-14760],[-3360,52140],[28800,52140],[28800,-14760]], {
            color: "black",
            fillOpacity: 0.6,
            weight: 0,
            interactive: false,
          }
          ).addTo(global.zapt.map);
        }
        let hasProductionUnitExams =
          statusData["BR"] &&
          statusData["BR"]["TOTAL"];

        if (!hasProductionUnitExams) {
          return;
        }

        this.markers[statePoi.title] = global.L.marker(
          global.L.latLng([statePoi.y, statePoi.x]),
          {
            icon: global.L.divIcon({
              className: "",
              html: `
                <a 
                class="pin ${
                  STAGE_COLORS_UPPERCASE['CADASTRADO'] || "pin-tube"
                }" 
                > 
                <div class="pin-unit-label">
                  <span class="pin-unit-name"> ${
                    userType === "PSC" ? "HP "+clientID : "LC "+clientID 
                  }</span>
                  <span class="pin-unit-qty" style="background: ${
                    STAGE_COLOR_CODE['CADASTRADO']
                  };">${
                (hasProductionUnitExams) ||"0"
              }</span>
                </div>
                <div class="pin-pulse"><span></span></div>
              </a>`,
              iconAnchor: [20, 40],
              iconSize: [40, 80],
            }),
          }
        );

        if(!isHighlight){
          this.markers[statePoi.title].on("mouseout", () => {
            setTimeout(() => {
              !this.isOnUnitCardOver && this.markers["unit-card"]?.remove();
              !this.isOnUnitCardOver && this.highlightUnit();
            }, 10);
          });
  
          this.markers[statePoi.title].on("mouseover", async () => {
            let examsList = (this.state.exams && this.state.exams !== "no-results") ?
              this.state.exams.statistics :
              this.props.status;
              await this.renderCardUnit(
              statePoi.title,
              isHistory ? {BR: {CADASTRADO: 1, TOTAL: 1}, } :examsList,
              isHistory,
              true,
              "CADASTRADO"
            );
            this.highlightUnit(statePoi.title);
          });
        }


        this.markers[statePoi.title].addTo(global.zapt.map);
        focusOnMarkers.push(this.markers[statePoi.title]);

        if (focusOnMarkers.length > 0) {
          let group = new global.L.featureGroup(focusOnMarkers);

          !isHighlight && this.focusOnTheMap(
            global.zapt.map,
            group
          );
        }
      }
    }
  }

  async loadCollectedMarkers(status, isHighlight = false,isHistory = false) {
    let isMapInitialized =
      this.zaptMapAPI &&
      this.zaptMapAPI._map.map &&
      global.L &&
      global.zapt &&
      global.zapt.map;
    let statusData = status && Object.keys(status).length > 0 && status;
    let routeInfo = {
      origin: '',
      destinations: [],
    };
    let clientID = userService.getClientId();
    let clientState = this.getClientState();

    if (isMapInitialized && statusData) {
        //Load pointer origem
        let pois = await this.zaptMapAPI.getPois();
        let statesPois = filterPois(
          pois,
          this.state.currentMapId,
          STATES_CATEGORY,
        );
        let statePoi = filterPoiByName(statesPois, clientState);
        if(statePoi){
          this.clearMarkers();
          if(isHistory){
            global.L.polygon([[-3360,-14760],[-3360,52140],[28800,52140],[28800,-14760]], {
              color: "black",
              fillOpacity: 0.6,
              weight: 0,
              interactive: false,
            }
            ).addTo(global.zapt.map);
          }
          routeInfo.origin = statePoi.title;
          this.markers[statePoi.title] = global.L.marker(
            global.L.latLng([statePoi.y, statePoi.x]),
            {
              icon: global.L.divIcon({
                className: "",
                html: `
                  <a class="dot-pointer dot-origem
                   style="top: 40%; left:50%;"> 
                  <div class="dot-label">
                    ${"LC "+clientID || ""}
                  </div>
                  <div class="dot"><span></span></div>
                </a>`,
                iconAnchor: [20, 40],
                iconSize: [40, 80],
              }),
            }
          );
          this.markers[statePoi.title].addTo(global.zapt.map);
        }

        //load pointes destino
        pois = await this.zaptMapAPI.getPois();
        let unitPois = filterPois(
          pois,
          this.state.currentMapId,
          PRODUCTION_UNIT_CATEGORY,
          );
        if(unitPois){
          for(let unitPoiIndex in unitPois){
            let productionUnitPoi = unitPois[unitPoiIndex];
            let productionUnitExam = isHighlight ? 
            statusData[productionUnitPoi.title] :
              statusData[productionUnitPoi.title] &&
              statusData[productionUnitPoi.title]["TOTAL"];

            if(!productionUnitExam){
              continue;
            }
            routeInfo.destinations.push({
              title:productionUnitPoi.title,
              total: productionUnitExam
            });
            this.markers[productionUnitPoi.title] = global.L.marker(
              global.L.latLng([productionUnitPoi.y, productionUnitPoi.x]),
              {
                icon: global.L.divIcon({
                  className: "",
                  html: `
                    <a class="dot-pointer dot-destino
                     style="top: 40%; left:50%;"> 
                    <div class="dot-label">
                      ${PRODUCTION_UNIT_ALIAS[productionUnitPoi.title] || ""}
                    </div>
                    <div class="dot"><span></span></div>
                  </a>`,
                  iconAnchor: [20, 40],
                  iconSize: [40, 80],
                }),
              }
            );
            this.markers[productionUnitPoi.title].addTo(global.zapt.map);
          }
        }
        this.logisticRoutes = this.loadLogisticRoutes(routeInfo);

        if (this.logisticRoutes.length > 0) {
          let group = new global.L.featureGroup(this.logisticRoutes);
          group.addTo(global.zapt.map);
          if(global.zapt.map.getZoom() < 0.5){
            this.logisticRoutes.forEach(layer => {
              layer.dragging && global.zapt.map.removeLayer(layer);
            });
          }
          !isHighlight && this.focusOnTheMap(global.zapt.map,group);
          !isHighlight && global.zapt.map.on('zoomend', this.clearLogisticLabelsFn);
          this.setState({fullLegend: true});
          this.renderLegendFn();
        }
    }
  }

  loadLogisticRoutes(routeInfo){
    let routeComponents = [];
    if(routeInfo && 
      routeInfo.origin && 
      routeInfo.origin !== "" && 
      routeInfo.destinations && 
      routeInfo.destinations.length > 0)
    {
      let originPath = this.markers[routeInfo.origin];
      for(let destination of routeInfo.destinations){
        if(this.markers[destination.title] && originPath){
          let aliasProdUnit = PRODUCTION_UNIT_ALIAS[destination.title];
          let transportType = 
            (routeInfo.origin === PRODUCTION_UNIT_FEDERATIONS[aliasProdUnit]) ? 'road': 'air';
          let destinationPath = this.markers[destination.title];
          let direction = getCoordinateDirection(
            destinationPath['_latlng'].lng,
            originPath['_latlng'].lng
          );
          let routePath = (transportType === 'road') ? [destinationPath['_latlng'], originPath['_latlng']] :
            calculateCurvePoints(
              50,
              {x: destinationPath['_latlng'].lat, y: destinationPath['_latlng'].lng},
              {x: originPath['_latlng'].lat, y:originPath['_latlng'].lng},
              0.6,
              direction === "back",
            );
          let route = global.L.polyline(routePath,
            {
              color: "#0030B6",
              weight: "3",
              dashArray: "3, 5",
              dashOffset: "0",
            }
          );
          routeComponents.push(route);

          let centerRoute = transportType === 'road' ? this.calcCenterRoute([
            this.markers[destination.title]['_latlng'],
            originPath['_latlng']
          ]): routePath[Math.round(routePath.length/2)+1];

          let label = global.L.marker(
            global.L.latLng(centerRoute),
            {
              icon: global.L.divIcon({
                className: "",
                html: `
                  <div class="route-label route-label-${transportType}-${direction}"> 
                  <div class="route-label-number route-label-number-alert">
                    ${destination.total}
                  </div>
                </div>`,
                iconAnchor: [20, 30],
                iconSize: [40, 60],
              }),
            }
          );
          routeComponents.push(label);
        }
      }
    }
    return routeComponents;
  }
  calcCenterRoute(pathRoute){
    if(pathRoute){
      return [
        Math.abs((pathRoute[0].lat + pathRoute[1].lat)/2),
        Math.abs((pathRoute[0].lng + pathRoute[1].lng)/2)
      ]
    }
    return [];
  }

  checkForSingleStatus(status) {
    if (status && status["BR"]) {
      for (const statusName in status["BR"]) {
        if (Object.hasOwnProperty.call(status["BR"], statusName)) {
          const statusTotal = status["BR"][statusName];
          if (statusTotal === status["BR"].TOTAL && statusName !== "TOTAL") {
            return statusName;
          }
        }
      }
    }

    return null;
  }

  async loadSingleProductionUnit(status, productionUnit) {
    let isMapInitialized =
      this.zaptMapAPI &&
      this.zaptMapAPI._map.map &&
      global.L &&
      global.zapt &&
      global.zapt.map;
    let statusData = status && Object.keys(status).length > 0 && status;
    let hasSingleStatus = this.checkForSingleStatus(statusData);
    let focusOnMarkers = [];

    if (isMapInitialized && statusData) {
      let pois = await this.zaptMapAPI.getPois();

      let productionUnitPois = filterPois(
        pois,
        this.state.currentMapId,
        PRODUCTION_UNIT_CATEGORY
      );

      let theProductionUnit = filterPoiByName(
        productionUnitPois,
        productionUnit
      );

      if (theProductionUnit) {
        this.clearMarkers();

        const productionUnitPoi = theProductionUnit;
        const isProductionUnitPoiWithMap = this.checkIfIsProductionUnitHasMap(
          productionUnitPoi.title
        );

        let hasProductionUnitExams =
          statusData[productionUnitPoi.title] &&
          statusData[productionUnitPoi.title]["TOTAL"];

        if (!hasProductionUnitExams) {
          return;
        }

        this.markers[productionUnit] = global.L.marker(
          global.L.latLng([productionUnitPoi.y, productionUnitPoi.x]),
          {
            icon: global.L.divIcon({
              className: "",
              html: `
                <a 
                class="pin ${
                  STAGE_COLORS_UPPERCASE[hasSingleStatus] || "pin-tube"
                }" 
                > 
                 <div class="pin-unit-label">
                   <span class="pin-unit-name"> ${
                     statusData[productionUnitPoi.title]?.aliasProdUnit || ""
                   }</span>
                   <span class="pin-unit-qty" style="background: ${
                     STAGE_COLOR_CODE[hasSingleStatus]
                   };">${
                (statusData[productionUnitPoi.title] &&
                  statusData[productionUnitPoi.title]["TOTAL"]) ||
                "0"
              }</span>
                </div>
                <div class="pin-pulse"><span></span></div>
              </a>
             `,
              iconAnchor: [20, 40],
              iconSize: [20, 20],
            }),
          }
        );

        this.markers[productionUnitPoi.title].on("click", () => {
          sendEvent("apply-production-unit-filter", {
            productionUnit: productionUnitPoi.title,
          });
        });

        this.markers[productionUnitPoi.title].on("mouseout", () => {
          setTimeout(() => {
            !this.isOnUnitCardOver && this.markers["unit-card"]?.remove();
            !this.isOnUnitCardOver && this.highlightUnit();
          }, 10);
        });

        this.markers[productionUnitPoi.title].on("mouseover", async () => {
          let examsList = (this.state.exams && this.state.exams !== "no-results") ?
            this.state.exams.statistics :
            this.props.status;
          await this.renderCardUnit(
            productionUnitPoi.title,
            examsList,
            false,
            false,
            isProductionUnitPoiWithMap
          );
          this.highlightUnit(productionUnitPoi.title);
        });

        this.markers[productionUnit].addTo(global.zapt.map);
        focusOnMarkers.push(this.markers[productionUnit]);

        if (focusOnMarkers.length > 0) {
          let group = new global.L.featureGroup(focusOnMarkers);
          this.focusOnTheMap(global.zapt.map, group);
        }
      }
    }
  }

  highlightUnit(productionUnit, focus) {
    for (const unitMarker in this.markers) {
      if (Object.hasOwnProperty.call(this.markers, unitMarker)) {
        try {
          const marker = this.markers[unitMarker];
          if (!productionUnit) {
            marker.setOpacity(1);
          } else if (
            !(unitMarker === productionUnit) &&
            !("unit-card" === unitMarker)
          ) {
            marker.setOpacity(0.5);
          } else {
            marker.setOpacity(1);
          }

          if (focus) {
            let group = new global.L.featureGroup([marker]);
            this.focusOnTheMap(global.zapt.map, group);
          }
        } catch (error) {
          console.error("Production unit highlight failure",error);
        }
      }
    }
  }

  async setExams(event) {
    return new Promise((resolve, reject) => {
      let exams = event && event.detail;
      let requestChangeContext = async (resolve) => {
        await this.handleMapView();
        resolve();
      };

      if (this.state.isMapInitialized) {
        this.setState(
          { exams: exams },
          requestChangeContext.bind(this, resolve)
        );
      } else if (exams) {
        this.setState(
          { exams: exams },
          requestChangeContext.bind(this, resolve)
        );
      }

      if (!exams) {
        this.setState({ exams: null, videoVisible: false });
      }
    });
  }

  resetMapZoom() {
    if (this.zaptMapAPI && this.zaptMapAPI.setZoom && (!this.checkIfIsDefaultProductionUnitMap() && this.state.examHistory)) {
      this.zaptMapAPI.setZoom(
        this.checkIfIsDefaultProductionUnitMap() ? -1.69 : -2.69
      );
      this.setState({ examOnHighlight: null });
    }
  }

  highlightExam(event) {
    try {
      let exam = event && event.detail;
      let notAllowed =
        exam &&
        (exam.eventStage === "Recolhido" || exam.eventStage === "Cadastrado");

      if (
        exam &&
        !notAllowed &&
        exam.eventStage &&
        this.state.examOnHighlight !== exam.examId &&
        !this.state.videoVisible
      ) {
        let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();

        if (isDefaultProductionUnit) {
          let productionUnit = exam.productionUnit;

          if (this.markers[productionUnit] && global.zapt && global.zapt.map) {
            let group = new global.L.featureGroup([
              this.markers[productionUnit],
            ]);
            this.focusOnTheMap(global.zapt.map, group);
          }
          return;
        }

        let eventStage = exam.eventStage.toUpperCase();

        if (this.markers[eventStage] && global.zapt && global.zapt.map) {
          let group = new global.L.featureGroup([this.markers[eventStage]]);

          this.focusOnTheMap(global.zapt.map, group);
        }

        this.setState({ examOnHighlight: exam.examId });
      } else {
        this.setState({ examOnHighlight: null });
      }
    } catch (error) {
      console.error("Error trying to highlight exam on map: ", error.message);
      this.setState({ examOnHighlight: null });
    }
  }

  async loadExamGroupings(examsDistribution) {
    try {
      let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();
      let isMapInitialized =
        this.zaptMapAPI &&
        this.zaptMapAPI._map.map &&
        global.L &&
        global.zapt &&
        global.zapt.map;
      let hasStatus =
        examsDistribution && Object.keys(examsDistribution).length > 0;

      if (!isDefaultProductionUnit && isMapInitialized && hasStatus) {
        let pois = await this.zaptMapAPI.getPois();

        let stagesPois = filterPois(
          pois,
          this.state.currentMapId,
          STAGES_CATEGORY
        );

        if (stagesPois) {
          this.clearMarkers();
          for (const index in stagesPois) {
            const stagePoi = stagesPois[index];
            if (!STAGE_COLORS[stagePoi.title] || !stagePoi) {
              continue;
            }

            let hasProductionExams =
              examsDistribution[this.state.mapExternalId] &&
              examsDistribution[this.state.mapExternalId][
                stagePoi.title.toUpperCase()
              ];

            if (!hasProductionExams) {
              continue;
            }

            this.markers[stagePoi.title.toUpperCase()] = global.L.marker(
              global.L.latLng([stagePoi.y, stagePoi.x]),
              {
                icon: global.L.divIcon({
                  className: "",
                  html: `
                    <div 
                    class="pin ${STAGE_COLORS[stagePoi.title] || "pin-todos"}" 
                    style="top: 13%; left: 65%; cursor: pointer;"
                    data-bs-toggle="tooltip"
                    title="${STAGE_SHORT[stagePoi.title.toUpperCase()]}">
                      <div class="pin-number" style="color: grey;">
                      ${
                        (examsDistribution[this.state.mapExternalId] &&
                          examsDistribution[this.state.mapExternalId][
                            stagePoi.title.toUpperCase()
                          ]) ||
                        "0"
                      }
                      </div>
                      <div class="pin-pulse"><span></span></div>
                    </div>
                  `,
                  iconAnchor: [20, 40],
                  iconSize: [20, 20],
                }),
              }
            );

            this.markers[stagePoi.title.toUpperCase()].on('click', ()=>{
              sendEvent("apply-stage-production-unit-filter", { 
                productionUnit: this.state.mapExternalId,
                stage: stagePoi.title.toUpperCase(),
              });
            });

            this.markers[stagePoi.title.toUpperCase()].addTo(global.zapt.map);
          }
        }
      }
      return true;
    } catch (error) {
      console.error("Erro trying to load production units: ", error.message);
    }
  }

  async loadExamsOnMap() {
    let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();
    let isMapInitialized =
      this.zaptMapAPI &&
      this.zaptMapAPI._map.map &&
      global.L &&
      global.zapt &&
      global.zapt.map;
    let hasExams = this.state.exams && this.state.exams.length !== null;

    if (!isDefaultProductionUnit && isMapInitialized && hasExams) {
      let pois = await this.zaptMapAPI.getPois();

      let stagesPois = filterPois(
        pois,
        this.state.currentMapId,
        STAGES_CATEGORY
      );

      stagesPois = this.buildStagesPois(stagesPois);

      let examsCountByStage = this.countExamsByStage(this.state.exams);

      if (stagesPois) {
        this.clearMarkers();

        for (const stageIndex in examsCountByStage) {
          const stagePoi = stagesPois[stageIndex];
          const stageCount = examsCountByStage[stageIndex];

          if (!stagePoi) {
            continue;
          }

          if (this.markers[stageIndex]) {
            this.markers[stageIndex].remove();
          }

          this.markers[stageIndex] = global.L.marker(
            global.L.latLng([
              stagesPois[stageIndex].y,
              parseInt(stagesPois[stageIndex].x),
            ]),
            {
              icon: global.L.divIcon({
                className: "",
                html: `<div class="pin ${
                  STAGE_COLORS[stagesPois[stageIndex].title] || "pin-todos"
                }" style="top: 13%; left: 65%; cursor: auto;">
                <div class="pin-number" style="color: grey;">${
                  stageCount || "0"
                }</div>
                  <div class="pin-pulse"><span></span></div>
                </div>`,
                iconAnchor: [20, 40],
                iconSize: [20, 20],
              }),
            }
          );
          this.markers[stageIndex].addTo(global.zapt.map);
        }
      }
    }
  }

  async setExamHistory(event) {
    return new Promise((resolve, reject) => {
      let requestChangeContext = async (resolve) => {
        await this.handleMapView();
        resolve();
      };

      if (event && event.detail) {
        this.setState(
          { examHistory: event.detail },
          requestChangeContext.bind(this, resolve)
        );
      } else {
        this.setState(
          { examHistory: null },
          requestChangeContext.bind(this, resolve)
        );
      }
    });
  }

  checkDuplicateOccurrences(history){
    let occurrences = {};
    history.map((stage, index)=>{
      let stageName = stage.stageName;
      if(occurrences.hasOwnProperty(stageName)){
        occurrences[stageName].indexes.push(index);
        occurrences[stageName].occurrences += 1;
      }else{
        occurrences[stageName] = {
          indexes:[index],
          occurrences: 1
        };
      }
    })
    return occurrences;
  }

  async loadHistoryOnMap(event) {
    try {
      let examHistory = event && event.examHistory;
      let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();
      let isMapInitialized =
        this.zaptMapAPI &&
        this.zaptMapAPI._map.map &&
        global.L &&
        global.zapt &&
        global.zapt.map;
      let occurrences  = this.checkDuplicateOccurrences(examHistory);
      if (isDefaultProductionUnit) {
        let group = new global.L.featureGroup([
          this.markers[event && event.productionUnit],
        ]);
        this.setState({ loading: false });

        this.focusOnTheMap(global.zapt.map, group);

        return;
      }

      if (!isDefaultProductionUnit && isMapInitialized && examHistory) {
        let pois = await this.zaptMapAPI.getPois();
        let lastHistoryStage =
          examHistory &&
          examHistory.length &&
          examHistory[examHistory.length - 1];

        let stagesPois = filterPois(
          pois,
          this.state.currentMapId,
          STAGES_CATEGORY
        );
        stagesPois = this.buildStagesPois(stagesPois);

        let markers = [];

        examHistory.forEach((item, index) => {
          if (stagesPois && stagesPois[item.stageName]) {
            let markerStyle = {};
            let lastOccurrence = occurrences[item.stageName].indexes.length -1;
            if((occurrences[item.stageName].occurrences === 1 || 
              index === occurrences[item.stageName].indexes[lastOccurrence]))
            {
              if (index < examHistory.length-1) {
                markerStyle["icon"] = global.L.divIcon({
                  className: "",
                  html: `<div 
                            class="pin-generic 
                            ${STAGE_COLORS[stagesPois[item.stageName].title] ||
                              "pin-todos"}" 
                            data-bs-toggle="tooltip"
                            title="${occurrences[item.stageName].indexes.map(index =>{
                              return (index+1)+" - "+moment(examHistory[index].dateHour).format(
                                "DD/MM/YYYY HH:mm"
                              )+"\n"
                            })}"
                            >`.replaceAll(',','')+`
                            <div class="pin-number-generic
                            ${occurrences[item.stageName].occurrences > 1 ? 'pin-number-return': ""}"
                            ${
                              ["Recebido", "Recoleta"].includes(item.stageName)
                                ? "style=transform:translateX(27%);"
                                : ["Em Processamento"].includes(item.stageName)
                                ? "style=transform:translateX(15%);"
                                : ""
                            }\>
                            ${`${occurrences[item.stageName].indexes.map((order, index)=>{
                              let numOccurrences = occurrences[item.stageName].occurrences;
                              if(index === numOccurrences-1 && numOccurrences > 1){
                                return " e "+(order+1)
                              }
                              return " "+(order+1)
                            })}
                            - ${STAGE_SHORT[item.stageName.toUpperCase()]}` || ""}
                            </div>
                          </div>
                          </div>`.replaceAll(', e', ' e'),
                  iconAnchor: [0, 20],
                  iconSize: [20, 20],
                });
              } else {
                markerStyle["icon"] = global.L.divIcon({
                  className: "",
                  html: `<div 
                      class="pin ${
                        STAGE_COLORS[
                          stagesPois[lastHistoryStage.stageName].title
                        ] || "pin-todos"
                      }" 
                      data-bs-toggle="tooltip"
                              title="${occurrences[item.stageName].indexes.map(index =>{
                                return (index+1)+" - "+moment(examHistory[index].dateHour).format(
                                  "DD/MM/YYYY HH:mm"
                                )+"\n"
                              })}"
                      style="top: 13%; 
                      left: 65%; 
                      cursor: default;">`.replaceAll(',','')+`
                        <div class="pin-number ${occurrences[item.stageName].occurrences > 1 ? 'pin-number-return': ""}" style="color: white; background: transparent">
                          ${`${occurrences[item.stageName].indexes.map((order, index)=>{
                            let numOccurrences = occurrences[item.stageName].occurrences;
                            if(index === numOccurrences-1 && numOccurrences > 1){
                              return " e "+(order+1)
                            }
                            return " "+(order+1)
                          })} - ${STAGE_SHORT[item.stageName.toUpperCase()]}` || ""}
                        </div>
                        <div class="pin-pulse"><span></span></div>
                      </div>`.replaceAll(', e', ' e'),
                  iconAnchor: [20, 40],
                  iconSize: [20, 20],
                });
              }
              markers.push(
                global.L.marker(
                  global.L.latLng([
                    stagesPois[item.stageName].y,
                    parseInt(stagesPois[item.stageName].x),
                  ]),
                  markerStyle
                )
              );
            }
          }
        });

        if (markers && markers.length >= 1) {
          this.clearMarkers();
          markers.forEach((item) => item.addTo(global.zapt.map));
          this.traceHistoryRoute(examHistory);
        }
        addPaddingInMap({left: 0});
        global.zapt && global.zapt.map && global.zapt.map.invalidateSize();
      }
    } catch (error) {
      console.error(
        "Error trying to draw exam history on map: ",
        error.message
      );
    }
  }

  async highlightStage(stage) {
    if(!this.checkIfIsDefaultProductionUnitMap()){
      return;   
    }
    let isDefaultProductionUnit = this.checkIfIsDefaultProductionUnitMap();
    let isMapInitialized =
      this.zaptMapAPI &&
      this.zaptMapAPI._map.map &&
      global.L &&
      global.zapt &&
      global.zapt.map;
    let statusData =
      this.props.stageUnitDistributionByStage &&
      Object.keys(this.props.stageUnitDistributionByStage).length > 0 &&
      this.props.stageUnitDistributionByStage;
      stage = stage && stage.detail && stage.detail.toUpperCase();
    if(stage === 'CADASTRADO'){
      let stageUnitDistribution =
      statusData && stage && statusData[stage] && statusData[stage];
      let totalExams = 0;
      for(let unitKey in stageUnitDistribution){
        totalExams += stageUnitDistribution[unitKey];
      }
      if(totalExams > 0){
        let units = statusData &&
                    statusData['CADASTRADO'] &&
                    statusData['CADASTRADO'];
        let stageDate = {
          BR: {
            TOTAL: totalExams,
          },
          ...units
        }
        this.setState({ isStageHighlightOn: true });
        await this.loadRegisteredMarker(stageDate, true);
      }else{
        this.clearMarkers();
      }
      return;
    }

    if(stage === 'RECOLHIDO'){
      let stageUnitDistribution =
      statusData && stage && statusData[stage] && statusData[stage];
      let totalExams = 0;
      for(let unitKey in stageUnitDistribution){
        totalExams += stageUnitDistribution[unitKey];
      }
      if(totalExams > 0){
        this.setState({ isStageHighlightOn: true });
        await this.loadCollectedMarkers(stageUnitDistribution, true, false);
      }else{
        this.clearMarkers();
      }
      return;
    }
    let stageUnitDistribution =
      statusData && stage && statusData[stage] && statusData[stage];
    let productionUnitAliases = statusData && statusData["aliasProdUnit"];

    if (stageUnitDistribution && isMapInitialized && isDefaultProductionUnit) {
      let pois = await this.zaptMapAPI.getPois();

      let productionUnitPois = filterPois(
        pois,
        this.state.currentMapId,
        PRODUCTION_UNIT_CATEGORY
      );

      let isValidProductionUnitMap = this.checkIfIsProductionUnitHasMap();

      if (productionUnitPois) {
        this.clearMarkers();
        this.setState({ isStageHighlightOn: true });
        for (const index in productionUnitPois) {
          const productionUnitPoi = productionUnitPois[index];

          if (!isValidProductionUnitMap) {
            continue;
          }

          let hasProductionUnitExams =
            stageUnitDistribution[productionUnitPoi.title];

          if (!hasProductionUnitExams) {
            continue;
          }

          this.markers[productionUnitPoi.title] = global.L.marker(
            global.L.latLng([productionUnitPoi.y, productionUnitPoi.x]),
            {
              icon: global.L.divIcon({
                className: "",
                html: `
                 <div
                  class="pin ${STAGE_COLORS_UPPERCASE[stage] || "pin-tube"}" 
                 > 
                  <div class="pin-unit-label">
                    <span class="pin-unit-name"> ${
                      (productionUnitAliases &&
                        productionUnitAliases[productionUnitPoi.title]) ||
                      ""
                    }</span>
                    <span class="pin-unit-qty" style="background: ${
                      STAGE_COLOR_CODE[stage]
                    };">${
                  stageUnitDistribution[productionUnitPoi.title] || "0"
                }</span>
                  </div>
                  <div class="pin-pulse"><span></span></div>
                </div>`,
                iconAnchor: [20, 40],
                iconSize: [40, 80],
              }),
            }
          );
          this.markers[productionUnitPoi.title].addTo(global.zapt.map);
        }
      }
    }
  }

  traceHistoryRoute(history) {
    if (history && history.length > 1) {
      let routes = this.mountHistoryRoute(history);
      this.markers["history-black-window"] = global.L.polygon(this.mapBounds, {
        color: "black",
        fillOpacity: 0.6,
        weight: 0,
        interactive: false,
      }).addTo(global.zapt.map);

      if (routes.route && routes.route.length > 0) {
        let leafletRoute = routes.route.map((item) =>
          transformCoordinatesToLeaflet(item)
        );

        global.L.polyline(leafletRoute, {
          color: "#51CFFE",
          weight: "1.5",
          dashArray: "1.5, 2.5",
          dashOffset: "0",
        }).addTo(global.zapt.map);
      }

      if (routes.routePendency && routes.routePendency.length > 0) {
        let leafletRoute = routes.routePendency.map((item) =>
          transformCoordinatesToLeaflet(item)
        );

        global.L.polyline(leafletRoute, {
          color: "#E58148",
          weight: "1.5",
          dashArray: "1.5, 2.5",
          dashOffset: "0",
        }).addTo(global.zapt.map);
      }
    }
  }

  mountHistoryRoute(history) {
    let route = [];
    let routePendency = []
    let paths = [];
    if(this.state.mapSelectedType && this.state.mapSelectedType === "3D"){
      if(this.state.mapExternalId && this.state.mapExternalId === "NTO"){
        paths = HISTORY_ROUTES;
      }else{
        paths = HISTORY_ROUTES_GENERIC;
      }
    }else if(this.state.mapSelectedType === "FLAT"){
      if(this.state.mapExternalId && this.state.mapExternalId === "NTO"){
        paths = HISTORY_ROUTES_FLAT
      }else{
        paths = HISTORY_ROUTES_FLAT_GENERIC
      }
    }
    for (let index = 0; index < history.length; index++) {
      let pathLabel = `${history[index].stageName}-${history[index + 1]?.stageName}`
      let path = paths[pathLabel];
      if (path) {
        if(pathLabel.toUpperCase().indexOf('RECOLETA') !== -1 ||
          pathLabel.toUpperCase().indexOf('PENDÊNCIA') !== -1)
        {
          routePendency = routePendency.concat(path)
        }else{
          route = route.concat(path);
        }
      }
    }

    return {route, routePendency};
  }

  updateLimitMapBounds(fator) {
    this.mapBounds = [];
    if (global.zapt && global.zapt.map) {
      const SouthWest = global.zapt.map?.getBounds().getSouthWest();
      const SouthEast = global.zapt.map?.getBounds().getSouthEast();
      const NorthEast = global.zapt.map?.getBounds().getNorthEast();
      const NorthWest = global.zapt.map?.getBounds().getNorthWest();

      this.mapBounds.push([SouthWest.lat * fator, SouthWest.lng * fator]);
      this.mapBounds.push([SouthEast.lat * fator, SouthEast.lng * fator]);
      this.mapBounds.push([NorthEast.lat * fator, NorthEast.lng * fator]);
      this.mapBounds.push([NorthWest.lat * fator, NorthWest.lng * fator]);
      return true;
    }

    return false;
  }

  clearMarkers() {
    if (global.zapt && global.zapt.map) {
      this.markers = {};
      this.logisticRoutes = [];
      global.zapt.map.eachLayer((layer) => {
        if ((layer.dragging && layer.dragging._marker) || layer._parts) {
          global.zapt.map.removeLayer(layer);
        }
      });
      this.setState({ fullLegend: false });
      global.zapt && global.zapt.map && global.zapt.map.off('zoomend', this.clearLogisticLabelsFn);
      this.renderLegendFn();
    }
  }

  clearLogisticLabels(e){
    if(e && e.target && e.target._zoom &&
      this.logisticRoutes && this.logisticRoutes.length > 0)
    {
      if(e.target._zoom <= 0.5){
        this.logisticRoutes.forEach(layer => {
          layer.dragging && global.zapt.map.removeLayer(layer);
        });
      }else{
        this.logisticRoutes.forEach(layer => {
          layer.dragging && layer.addTo(global.zapt.map);
        });
      }
    }
    return;
  }

  buildStagesPois(stagePois) {
    if (stagePois && Object.keys(stagePois).length > 0) {
      let buildedStagePois = {};

      for (const stagePoiIndex in stagePois) {
        const stagePoi = stagePois[stagePoiIndex];
        buildedStagePois[stagePoi.title] = stagePoi;
      }

      return buildedStagePois;
    }

    return null;
  }

  countExamsByStage(exams) {
    if (exams) {
      let examsCount = {};

      for (const exam of exams) {
        !examsCount[exam.eventStage]
          ? (examsCount[exam.eventStage] = 1)
          : examsCount[exam.eventStage]++;
      }

      return examsCount;
    }
  }

  async toggleTopView() {
    this.setState({ loading: true });
    if (this.state.mapSelectedType === "3D") {
      await this.loadMap(this.state.flatMapExternalId);
    } else {
      await this.loadMap(this.state.mapExternalId);
      this.addAnimationsInMap(this.state.mapExternalId);
    }
    this.handleMapView();
    this.setState({ loading: false });
  }

  changeZoom(zoom) {
    this.zaptMapAPI.setZoom(zoom);
  }

  getExamsDistribution() {
    return (
      this.state.exams && this.state.exams.exams && this.state.exams.statistics
    );
  }

  getMapLayer() {
    let mapLayer = null;

    if (global.zapt && global.zapt.map) {
      global.zapt.map.eachLayer((layer) => {
        if (layer._url && layer._image) {
          mapLayer = layer;
        }
      });
    }
    return mapLayer;
  }

  setZoom(value) {
    if (this.zaptMapAPI) {
      let currentZoom =
        this.zaptMapAPI.getZoom() != null ? this.zaptMapAPI.getZoom() : 0;

      if (value === "+") {
        this.changeZoom(currentZoom + 0.5);
      } else if (value === "-") {
        this.changeZoom(currentZoom - 0.5);
      }
    }
  }

  checkIfIsFlatMapId(mapId) {
    if (mapId && typeof mapId === "string") {
      let splittedMapId = mapId.split("-");

      return (
        splittedMapId &&
        splittedMapId.length &&
        splittedMapId[splittedMapId.length - 1] === "FLAT"
      );
    } else {
      return false;
    }
  }

  checkIfIsDefaultProductionUnitMap() {
    let isMainMapId = this.state.mainMapExternalId === this.state.mapExternalId;
    return isMainMapId;
  }

  checkIfIsTemporaryMap() {
    return (
      this.checkIfIsDefaultProductionUnitMap() &&
      this.props &&
      this.state.mapExternalId !== MAIN_MAP
    );
  }

  checkIfIsProductionUnitHasMap(productionUnit) {
    return PRODUCTION_UNIT_HAS_MAP[productionUnit || this.state.mapExternalId];
  }

  renderLegend() {
    if (global.zapt && global.zapt.map) {
      if (this.checkIfIsDefaultProductionUnitMap()) {
        if (this.markers['legend']) {
          global.zapt.map.removeLayer(this.markers["legend"]);
          delete this.markers['legend'];
        }
        let sizeContainer = global.zapt.map.getSize();
        let x = this.state.examHistory || this.state.windowWidth <= 820 ? sizeContainer.x -10: sizeContainer.x - sizeContainer.x * 0.27;
        let center = global.zapt.map.containerPointToLatLng([x, sizeContainer.y]);
        let path = [center.lat, center.lng]
        this.markers['legend'] = global.L.marker(path, {
          icon: global.L.divIcon({
            className: "",
            html: `
          <div class="legend-container"
            <h4 class="legend-title">Legenda</h4>
            ${this.state.fullLegend ? (
              `<div style="padding-top: 0.5rem">
                <div class="legend-item legend-item-origem">Origem</div>
                <div class="legend-item legend-item-destino">Destino</div>
                <div class="legend-item legend-item-radar">
                  A localização de origem e destino é aproximada
                </div>
                <div class="legend-item legend-item-alert">
                  O número exato das amostras será aferido ao chegar ao núcleo técnico de destino
                </div>
              </div>`
                
            ):(
              `<div class="legend-item legend-item-info">
                  A localização dos laboratórios e núcleos técnicos é aproximada
              </div>`
            )}
          </div>
        `,
            iconAnchor: [292, 91],
            iconSize: [292, 91],
          }),
        });
        this.markers['legend'].setZIndexOffset(600);
        this.markers['legend'].addTo(global.zapt.map);
      }
    }
  }

  render() {
    window.onresize = () => {
      this.setState({
        windowWidth: window.innerWidth,
      });
    };
    return (
      <>
        <div id="map-container" style={{ height: this.containerHeight }}>
          {this.state.videoVisible || this.state.videoIsPlaying ? (
            <video
              id="video-intro"
              autoPlay
              muted
              style={{
                width: "100%",
                height: this.containerHeight,
                position: "fixed",
                left: "18%",
                zIndex: 1,
              }}
              onPlay={() => this.setState({ videoIsPlaying: true })}
              onEnded={() => this.setState({ videoIsPlaying: false })}
            >
              <source src={this.state.videoPath} type="video/mp4"></source>
            </video>
          ) : null}
          {this.state.loading && !this.state.videoVisible ? (
            <LoadDNA loading={true} width="300px" height="300px" />
          ) : null}

          <div
            id="zapt-map"
            style={{
              position: "fixed",
              right: "0",
              visibility:
                this.state.loading ||
                this.state.videoVisible ||
                this.state.videoIsPlaying
                  ? "hidden"
                  : "visible",
              height: this.containerHeight,
              width:
                this.state.examHistory && this.state.examHistory.examHistory
                  ? this.state.windowWidth - 500
                  : this.state.windowWidth,
            }}
          >
            {!this.state.loading ? (
              <div className="btn-div"
                style={this.state.examHistory ? {right: "10px"}: {}}
              >
                <div className="btns">
                  <div 
                    className="info-real-time"
                    style={this.state.examHistory ? {backgroundColor: "rgba(77, 207, 255, 0.9)"} : {}}
                  >
                    Informações atualizadas em tempo real
                  </div>
                  <div className="top-vw">
                    <div
                      className="bt-glass top-view"
                      style={this.state.examHistory ? {backgroundColor: "rgba(249, 250, 255, 0.9)"} : {}}
                      onClick={() => this.toggleTopView()}
                      data-ignore={true}
                    >
                      {this.state.mapSelectedType === "3D"
                        ? "Visão topo"
                        : " Visão 3D"}
                    </div>
                  </div>
                  <div className="zoom-btns">
                    <div 
                      className="zoom-nav"
                      style={this.state.examHistory ? {backgroundColor: "rgba(249, 250, 255, 0.9)"} : {}}
                    >
                      <div
                        className="zoom-in"
                        data-ignore={true}
                        onClick={(event) => {
                          event.stopPropagation();
                          this.setZoom("+");
                        }}
                      >
                        +
                      </div>
                      <div
                        className="zoom-out"
                        data-ignore={true}
                        onClick={(event) => {
                          event.stopPropagation();
                          this.setZoom("-");
                        }}
                      >
                        -
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Map);
